import { Box, Container, Typography } from '@material-ui/core'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined'
import { Link, useLocation } from 'react-router-dom'

import Button from '@/components/button'
import { routes } from '@/routes/config'

import { useStyles } from './styles'

export const Finish = () => {
  const classes = useStyles()
  const location = useLocation()
  const state = location.state as { cancelled?: true } | null

  return (
    <Container className={classes.container}>
      <Box>
        <Box>
          {state?.cancelled ? (
            <>
              <div className={classes.problemIcon}>
                <ReportProblemOutlinedIcon />
              </div>
              <Typography variant='h1'>Diagnóstico cancelado.</Typography>
            </>
          ) : (
            <>
              <CheckCircleIcon className={classes.successIcon} />
              <Typography variant={'h1'}>Cadastro finalizado</Typography>
              <Typography variant={'h2'}>
                Os arquivos foram enviados para processamento
              </Typography>
            </>
          )}
        </Box>
      </Box>
      <Box>
        <Button
          component={Link}
          to={{
            pathname: routes.Diagnoses(),
            search: '?searchType=status&search=reported',
          }}
        >
          Ok. finalizar
        </Button>
      </Box>
    </Container>
  )
}
